import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "@windmill/react-ui";
import { FiAlertCircle } from "react-icons/fi";
import spinnerLoadingImage from "assets/img/spinner.gif";

const DuplicateModal = ({ show, onHide, onSkip, onUpdate }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpdate = async () => {
    try {
      setIsSubmitting(true);
      await onUpdate();
      onHide();
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSkip = async () => {
    try {
      setIsSubmitting(true);
      await onSkip();
      onHide();
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={show} onClose={onHide}>
      <ModalBody className="text-center custom-modal px-8 pt-6 pb-4">
        <span className="flex justify-center text-3xl mb-6 text-yellow-500">
          <FiAlertCircle />
        </span>
        <h2 className="text-xl font-medium mb-2 text-gray-800 dark:text-gray-200">
          Sight Seeing Already Exists
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
          Do you want to update it?
        </p>
      </ModalBody>

      <ModalFooter className="justify-center flex flex-col sm:flex-row gap-3">
        <Button
          layout="outline"
          danger
          className="w-full sm:w-auto h-12"
          onClick={handleSkip}
          disabled={isSubmitting}
        >
          Skip
        </Button>

        {isSubmitting ? (
          <Button disabled className="w-full sm:w-auto h-12 flex items-center justify-center">
            <img src={spinnerLoadingImage} alt="Loading" width={20} height={20} />
            <span className="ml-2 font-light">Processing</span>
          </Button>
        ) : (
          <Button className="w-full sm:w-auto h-12" onClick={handleUpdate}>
            Update
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default DuplicateModal;
